module.exports = __webpack_public_path__ + "img/currency.34494c44.png";